import _ from 'underscore';

import React from 'react';
import {
  APPLY_ACTION_TYPES,
  SUMMARY_CARD,
  RECOMMENDATIOIN_SUMMARY_APPLY_FAILED_RESULTS,
  RECOMMENDATION_TYPES,
  RECOMMENDATION_NOTIFICATION_REJECT_REASONS,
  IMPORT_TYPE,
  ADINSIGHT_LOG_ACTION_TYPE,
} from '@bingads-webui-campaign/recommendation-core';
import { getSessionStorage } from '@bingads-webui/storage';
import { formatNotificationLocalizedKey } from './formatter/format-notification';

const showLightboxNotification = ({
  aggregatedResult,
  view,
}) => {
  view.statusLightBox.viewModel.aggregatedResult(aggregatedResult);
  view.statusLightBox.trigger('show');
};

const getImportScheduleAndHistoryLink = (targetAccountId, scope, preferenceType) => {
  let queryParams = '';
  if (!_.isUndefined(scope.customerId) && !_.isUndefined(scope.userId)) {
    if (!_.isUndefined(scope.accountId)) {
      queryParams = `?aid=${scope.accountId}&cid=${scope.customerId}&uid=${scope.userId}&importType=${preferenceType}`;
    } else if (!_.isUndefined(targetAccountId)) {
      queryParams = `?aid=${targetAccountId}&cid=${scope.customerId}&uid=${scope.userId}&importType=${preferenceType}`;
    }
  }

  return `/campaign/vnext/importschedule${queryParams}`;
};

// TODO: separate each action type to different functions
const getNotificationMessage = ({
  op,
  i18n,
  totalRecommendationCount,
  successfulEntityCount,
  failedRecommendationCount,
  allExpired,
  otherInfo,
  newI18n = _.noop,
  scope = {},
  rawData,
}) => {
  let message = '';
  switch (op.userAction) {
    case APPLY_ACTION_TYPES.ACCEPT: {
      let n = 0;
      if (op.type === RECOMMENDATION_TYPES.REPAIR_ADS ||
        op.type === RECOMMENDATION_TYPES.REPAIR_KEYWORD) {
        n = failedRecommendationCount === 0 ? successfulEntityCount : totalRecommendationCount;
      } else if (allExpired) {
        n = totalRecommendationCount - failedRecommendationCount;
      } else {
        n = totalRecommendationCount;
      }

      const isSuccess = failedRecommendationCount === 0 || allExpired;
      if (op.type === RECOMMENDATION_TYPES.SSC_2_PMAX_MIGRATION && isSuccess) {
        message = n === 1 ? newI18n.getString(_TL_('Done! Your {n} smart shopping campaign is now upgraded to Performance Max campaign.')).replace('{n}', n)
          : newI18n.getString(_TL_('Done! Your {n} smart shopping campaigns are now upgraded to Performance Max campaigns.')).replace('{n}', n);
      } else if (op.type === RECOMMENDATION_TYPES.PMAX_IMPORT && isSuccess) {
        message = (
          <div>
            <span>{newI18n.getString(_TL_('Your Performance Max campaigns are scheduled to import 24 hours from now. You can review your'))}</span>
            <a
              href={`${getImportScheduleAndHistoryLink(op.targetAccountId, scope, IMPORT_TYPE.GOOGLE)}`}
              onClick={() => op.view.logOpportunityEvent({
                action: ADINSIGHT_LOG_ACTION_TYPE.REDIRECT,
                opportunityId: rawData.Results[0].OpportunityId,
                type: op.type,
                context: _.extend({
                  ImportTaskId: rawData.Results[0].ImportTaskId,
                }, op.context),
              })}
            >
              {newI18n.getString(_TL_(' Import schedule & history '))}
            </a>
            <span>{newI18n.getString(_TL_('at any time.'))}</span>
          </div>
        );
      } else if (op.type === RECOMMENDATION_TYPES.DSA_2_PMAX_MIGRATION && isSuccess) {
        message = newI18n.getString(_TL_('You\'ve upgraded your DSA campaigns to Performance Max campaigns.'));
      } else {
        message = i18n.getString(
          formatNotificationLocalizedKey({
            count: n,
            isSuccess,
            recommendationType: op.type,
            actionType: op.userAction,
            otherInfo,
          }),
          { n, ...otherInfo }
        );
      }

      break;
    }
    case APPLY_ACTION_TYPES.DISMISS:
    case APPLY_ACTION_TYPES.UNDISMISS: {
      message = i18n.getString(
        formatNotificationLocalizedKey({
          count: totalRecommendationCount,
          isSuccess: failedRecommendationCount === 0,
          recommendationType: op.type,
          actionType: op.userAction,
        }),
        { n: failedRecommendationCount > 0 ? failedRecommendationCount : totalRecommendationCount }
      );
      break;
    }
    case APPLY_ACTION_TYPES.REJECT: {
      if (failedRecommendationCount) {
        message = i18n.getString('Recommendation_Reject_Error_Message_For_Phase2');
      } else {
        message = i18n.getString(
          'Recommendation_Reject_Success_Message',
          { n: RECOMMENDATION_NOTIFICATION_REJECT_REASONS[op.reason ? op.reason.ReasonId : 'Other'] } //eslint-disable-line
        );
      }
      break;
    }
    default:
      break;
  }
  return message;
};

export const handleRecommendationNotification = ({
  i18n,
  op,
  rawData,
  showAlertHandler,
  isOptimizationScoreOn = false,
  setApplyNotificationInfo = _.noop,
  newI18n = _.noop,
  scope = {},
}) => {
  const {
    totalCount: totalRecommendationCount,
    failedCount: failedRecommendationCount,
    expiredCount,
    successfulCount,
  } = rawData;
  const expiredRecommendationCount = expiredCount + successfulCount;
  let successfulEntityCount = 0;
  let otherInfo = {};
  if (op.type === RECOMMENDATION_TYPES.REPAIR_ADS) {
    successfulEntityCount = _.chain(rawData.Results)
      .first()
      .result('AddAdResults')
      .filter(result => result.BatchErrorCode === 0)
      .size()
      .value();
  } else if (op.type === RECOMMENDATION_TYPES.REPAIR_KEYWORD) {
    successfulEntityCount = _.chain(rawData.Results)
      .first()
      .result('AddKeywordResults')
      .filter(result => result.BatchErrorCode === 0)
      .size()
      .value();
  }
  if (op.type === RECOMMENDATION_TYPES.FIX_AD_DESTINATION) {
    otherInfo = {
      SuccessAdsCount: 0,
      SuccessKeywordsCount: 0,
      FailedAdsCount: 0,
      FailedKeywordsCount: 0,
    };
    _.map(rawData.Results, (item) => {
      otherInfo.SuccessAdsCount += item.SuccessAdsCount;
      otherInfo.SuccessKeywordsCount += item.SuccessKeywordsCount;
      otherInfo.FailedAdsCount += item.FailedAdsCount;
      otherInfo.FailedKeywordsCount += item.FailedKeywordsCount;
    });
  }

  const allExpired = expiredRecommendationCount === totalRecommendationCount;
  const message = getNotificationMessage({
    op,
    i18n,
    totalRecommendationCount,
    successfulEntityCount,
    failedRecommendationCount,
    allExpired,
    otherInfo,
    rawData,
    newI18n,
    scope,
  });

  const aggregatedResult = {
    ..._.pick(
      rawData,
      'totalCount',
      'failedCount',
      'expiredCount',
      'successfulCount',
      'AggregatedResults'
    ),
    otherInfo,
  };

  if (op.userAction === APPLY_ACTION_TYPES.ACCEPT && failedRecommendationCount > 0) {
    getSessionStorage().set(RECOMMENDATIOIN_SUMMARY_APPLY_FAILED_RESULTS, {
      results: aggregatedResult,
      recommendationType: op.type,
    });

    if (op.from === SUMMARY_CARD) {
      if (allExpired) {
        if (!isOptimizationScoreOn) {
          showAlertHandler({
            message,
            level: 'Info',
            dismissible: true,
          });
        }
      } else {
        op.viewDetails(op.type)();
      }
    } else {
      showLightboxNotification({
        aggregatedResult,
        view: op.view,
      });
    }
  } else if (!isOptimizationScoreOn) {
    showAlertHandler({
      message,
      level: failedRecommendationCount > 0 ? 'Warning' : 'Info',
      dismissible: true,
    });
  }

  if (isOptimizationScoreOn) {
    if (op.userAction === APPLY_ACTION_TYPES.UNDISMISS) {
      showAlertHandler({
        message,
        level: failedRecommendationCount > 0 ? 'Warning' : 'Info',
        dismissible: true,
      });
    } else {
      setApplyNotificationInfo({
        message,
        totalRecommendationCount,
        failedRecommendationCount,
        allExpiredInSummary: allExpired && op.from === SUMMARY_CARD,
        userAction: op.userAction,
      });
    }
  }
};
